import { render } from "./SettingsForm.vue?vue&type=template&id=6bac851c&scoped=true"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"

import "./SettingsForm.vue?vue&type=style&index=0&id=6bac851c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bac851c"]])

export default __exports__